import { PokemonSprite } from "@/components/pokemon/pokemon-sprite";
import { Pokemon } from "prisma-layer";
import { Direction } from "types/battle-engine/battle";
import classNames from "classnames";
import { isXsScreen } from "@/utils/screen-size-check";

interface ProfileTeamDisplayProps {
  pokemons: Array<
    Pick<
      Pokemon,
      | "id"
      | "display_id"
      | "base_pokemon_name"
      | "level"
      | "talents"
      | "active_skills"
      | "is_shiny"
    >
  >;
  className?: string;
  onPokemonHover: (
    pokemon: ProfileTeamDisplayProps["pokemons"][0] | null,
  ) => void;
  activePokemonId?: number | string | null;
}

export function ProfileTeamDisplay({
  pokemons,
  className,
  onPokemonHover,
  activePokemonId,
}: ProfileTeamDisplayProps) {
  return (
    <div
      className={classNames(
        "grid grid-cols-4 gap-4 p-2 animate-fadeIn place-items-center overflow-visible",
        className,
      )}
      onMouseLeave={() => onPokemonHover(null)}
    >
      {pokemons.map((pokemon) => (
        <div
          key={pokemon.id}
          className={classNames(
            "flex flex-col h-14 items-center gap-2 relative cursor-pointer transition-all duration-300",
            activePokemonId && activePokemonId !== pokemon.id
              ? "opacity-40 grayscale-[0.5]"
              : "opacity-100",
            activePokemonId === pokemon.id
              ? "scale-110 z-10"
              : "hover:scale-110",
          )}
          onMouseEnter={() => onPokemonHover(pokemon)}
          onClick={() => onPokemonHover(pokemon)}
        >
          {/* Hitbox for precise hover control */}
          <div className="absolute inset-0 z-20" />

          <div className="relative overflow-visible pointer-events-none">
            <PokemonSprite
              pokemon={pokemon}
              style={{ scale: isXsScreen() ? 1.5 : 2.5 }}
              className="w-12 h-12"
              showShadow={true}
              direction={Direction.SE}
              animation="Idle"
            />
          </div>
          <div
            className={classNames(
              "border rounded-md px-2 shadow-md mt-auto absolute bottom-0 transition-all duration-300 z-10",
              activePokemonId === pokemon.id
                ? "bg-pk-yellow-3 border-pk-yellow-1 scale-110 shadow-pk-yellow-3/50"
                : "bg-pk-gray-1/90 border-pk-blue-3",
            )}
          >
            <span
              className={classNames(
                "text-[10px] font-bold drop-shadow-sm transition-colors",
                activePokemonId === pokemon.id
                  ? "text-pk-black"
                  : "text-pk-gray-5",
              )}
            >
              #{pokemon.display_id.slice(0, 6)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
